function readHeights() {
  const h = {};
  h.windowHeight = window.innerHeight;
  h.announcementHeight = getHeight('[data-section-type*="announcement"]');
  h.footerHeight = getHeight('[data-section-type*="footer"]');
  h.menuHeight = getHeight('[data-header-height]');
  h.headerHeight = h.menuHeight + h.announcementHeight;
  h.logoHeight = getFooterLogoWithPadding();
  return h;
}

function setVarsOnResize() {
  document.addEventListener(
    'theme:resize',
    setVars,
  );
  setVars();
}

function setVars() {
  const { windowHeight, announcementHeight, headerHeight, logoHeight, menuHeight, footerHeight } = readHeights();
  document.documentElement.style.setProperty('--full-screen', `${windowHeight}px`);
  document.documentElement.style.setProperty('--three-quarters', `${(windowHeight * (3 / 4))}px`);
  document.documentElement.style.setProperty('--two-thirds', `${(windowHeight * (2 / 3))}px`);
  document.documentElement.style.setProperty('--one-half', `${(windowHeight / 2)}px`);
  document.documentElement.style.setProperty('--one-third', `${(windowHeight / 3)}px`);
  document.documentElement.style.setProperty('--one-fifth', `${(windowHeight / 5)}px`);

  document.documentElement.style.setProperty('--menu-height', `${menuHeight}px`);
  document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

  document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
  document.documentElement.style.setProperty('--content-full', `${(windowHeight - headerHeight - (logoHeight / 2))}px`);
  document.documentElement.style.setProperty('--content-min', `${(windowHeight - headerHeight - footerHeight)}px`);
}

function getHeight(selector) {
  const el = document.querySelector(selector);
  if (el) {
    return el.clientHeight;
  } else {
    return 0;
  }
}

function getFooterLogoWithPadding() {
  const height = getHeight('[data-footer-logo]');
  if (height > 0) {
    return height + 20;
  } else {
    return 0;
  }
}

function setHeight(frame) {
  // sets the height of any frame passed in with the
  // tallest preventOverflowContent as well as any image in that frame
  const padding = 64;
  let tallest = 0;
  const wrappers = frame.querySelectorAll('.preventOverflowContent');
  wrappers.forEach(wrap => {
    if (wrap.offsetHeight > tallest) {
      tallest = wrap.offsetHeight;
    }
  });
  const images = frame.querySelectorAll('.image__hero__frame');
  const frames = [
    frame,
    ...images,
  ];
  frames.forEach(el => {
    el.style.setProperty('min-height', `${(tallest + padding)}px`);
  });
}
function preventOverflow(container) {
  const frames = container.querySelectorAll('.preventOverflow');
  if (frames) {
    frames.forEach(frame => {
      setHeight(frame);
      document.addEventListener('theme:resize', () => {
        setHeight(frame);
      });
    });
  }
}

export {preventOverflow, setVarsOnResize, readHeights};
